import Icon, { IconProps } from '@components/utils/icons/icon';
import { useTheme } from '@emotion/react';
import { ElementType } from 'react';

import { Button, ButtonProps } from '../button/Button';

type IconButtonStylingProps = {
    ariaLabel: NonNullable<HTMLButtonElement['ariaLabel']>;
    icon: IconProps['name'];
    color?: IconProps['color'];
};

export type IconButtonProps<As extends ElementType = 'button'> =
    IconButtonStylingProps &
        Omit<ButtonProps<As>, 'children' | 'leftIcon' | 'rightIcon'>;

export const IconButton = <As extends ElementType = 'button'>({
    as,
    ariaLabel,
    icon,
    color,
    variant,
    ...rest
}: IconButtonProps<As>) => {
    const theme = useTheme();
    const iconColor = color || theme.palette.common.white;

    return (
        <Button
            as={as as ElementType}
            aria-label={ariaLabel}
            variant={variant ?? 'ghost'}
            css={{ aspectRatio: '1/1' }}
            {...rest}
        >
            <Icon
                name={icon}
                size={rest.buttonSize === 'small' ? 'small' : 'medium'}
                color={iconColor}
            />
        </Button>
    );
};
